import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import { Button, Row, Col } from "react-bootstrap";
import ReactQuill from "react-quill"; 
import 'react-quill/dist/quill.snow.css'; 
import { toast } from "react-toastify";

function BlogForm({ show, handleClose, handleSubmit, blog }) {
  const [formData, setFormData] = useState({
    blog_title: blog?.blog_title || "",
    blog_body: blog?.blog_body || "", 
    blog_author: blog?.blog_author || "",
    blog_author_image: null,
    blog_date: blog?.blog_date || "",
    blog_image: null,
  });

 
  useEffect(() => {
    if (blog) {
      setFormData({
        blog_title: blog.blog_title,
        blog_body: blog.blog_body,
        blog_author: blog.blog_author,
        blog_author_image: null,
        blog_date: blog.blog_date,
        blog_image: null,
      });
    } else {
       
       setFormData({
        blog_title: "",
        blog_body: "",
        blog_author: "",
        blog_author_image: null,
        blog_date: "",
        blog_image: null,
      });
    }
  }, [blog, show]); 

  const handleChange = (e) => {
    const { name, value, type } = e.target;
    setFormData({
      ...formData,
      [name]: type === "file" ? e.target.files[0] : value,
    });
  };

  const handleQuillChange = (field, content) => {
    setFormData((prev) => ({
      ...prev,
      [field]: content, 
    }));
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    
    const isBlogTitleEmpty = formData.blog_title.replace(/<(.|\n)*?>/g, '').trim().length === 0;
    const isBlogBodyEmpty = formData.blog_body.replace(/<(.|\n)*?>/g, '').trim().length === 0;

    if (isBlogTitleEmpty) {
      toast.error("Blog Title cannot be empty!");
        return;
    }

    if (isBlogBodyEmpty) {
        toast.error("Blog Body cannot be empty!");
        return;
    }

    handleSubmit(formData);
    handleClose(); 
  };
  
  const titleModules = {
    toolbar: [
      ['bold', 'italic', 'underline'],
      [{ 'color': [] }],
      ['clean']
    ],
  };
  
  const bodyModules = {
    toolbar: [
      [{ 'header': [1, 2, 3, false] }],
      ['bold', 'italic', 'underline', 'strike', 'blockquote'],
      [{ 'color': [] }, { 'background': [] }],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }],
      [{ 'align': [] }],
      ['link', 'image'],
      ['clean']
    ],
  };
  
  const formats = [
    'header',
    'bold', 'italic', 'underline', 'strike', 'blockquote',
    'list', 'bullet', 'align',
    'link', 'image', 'color', 'background'
  ];

  return (
    <Modal
      contentClassName="modal-height"
      size="lg"
      className="popup-model blog-model-popup"
      show={show}
      onHide={handleClose}
    >
      <Modal.Header closeButton>
        <Modal.Title>{blog ? "Edit Blog" : "Add Blog"}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="add-category-div">
        <Form onSubmit={handleFormSubmit}>
          <Row>
            <Col>
              <Form.Group controlId="formBlogTitle" className="mb-3">
                <Form.Label>Blog Title</Form.Label>
                <ReactQuill
                  theme="snow"
                  value={formData.blog_title}
                  onChange={(content) => handleQuillChange('blog_title', content)}
                  modules={titleModules}
                  formats={formats}
                  placeholder="Enter blog title..."
                  style={{ height: '60px', marginBottom: '50px' }}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group controlId="formBlogAuthor" className="mb-3">
                <Form.Label>Blog Author</Form.Label>
                <Form.Control
                  type="text"
                  name="blog_author"
                  value={formData.blog_author}
                  onChange={handleChange}
                  required
                  maxLength={70}
                  minLength={1}
                />
              </Form.Group>
            </Col>
          </Row>

          <Form.Group controlId="formBlogBody" className="mb-3">
            <Form.Label>Blog Body</Form.Label>
            <ReactQuill
              theme="snow"
              value={formData.blog_body}
              onChange={(content) => handleQuillChange('blog_body', content)}
              modules={bodyModules}
              formats={formats}
              placeholder="Start writing your blog content here..."
              style={{ height: '300px', marginBottom: '50px' }}
            />
          </Form.Group>
          
          <Row>
            <Col md={6}>
                <Form.Group controlId="formBlogAuthorImage" className="mb-3">
                    <Form.Label>Blog Author Image</Form.Label>
                    <Form.Control
                    type="file"
                    name="blog_author_image"
                    onChange={handleChange}
                    accept="image/*"
                    />
                </Form.Group>
            </Col>
            <Col md={6}>
                <Form.Group controlId="formBlogDate" className="mb-3">
                    <Form.Label>Blog Date</Form.Label>
                    <Form.Control
                    type="date"
                    name="blog_date"
                    value={formData.blog_date}
                    onChange={handleChange}
                    required
                    />
                </Form.Group>
            </Col>
          </Row>


          <Form.Group controlId="formBlogImage" className="mb-4">
            <Form.Label>Blog Image</Form.Label>
            <Form.Control
              type="file"
              name="blog_image"
              onChange={handleChange}
              accept="image/*"
            />
          </Form.Group>

          <div className="text-center border-0">
          <Button
            variant="light"
            type="submit"
            className=" update-add-btn"
          >
            {blog ? "Update" : "Submit"}
          </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
}

export default BlogForm;